module.exports = __webpack_public_path__ + "img/bespoke70_29.7250954f.jpg";